import axios from 'axios'

const api = axios.create({
  baseURL: '/tracer',
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
})

export function apiGetGlobalSearch({
  vin,
  searchString,
  searchCategories = 'all',
}) {
  const params = new URLSearchParams({
    search_string: searchString,
  })
  if (searchCategories !== 'all') {
    params.append('search_categories', searchCategories.join(','))
  }
  return api
    .get(`/vin/${vin}/search?${params.toString()}`)
    .then((resp) => resp.data)
}
